// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioImage-RadioButtonContainer_cls1__P4oVo","cls2":"VeloRadioImage-RadioButtonContainer_cls2__wjLO5 VeloRadioImage-RadioButtonContainer_cls1__P4oVo"};